import "./ToastPartnerConnect.scss";
import { Carousel } from "antd";
import { memberState, mobileState } from "../../state/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function ToastPartnerConnect() {
  const mobile = useRecoilValue(mobileState);
  const [member] = useRecoilState(memberState);
  
  const buttonSet = <div className="button-set">
      <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary ant-btn-lg"} target="_blank" rel="noreferrer">Book a Demo</a>
      <a href={"https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029143-adding-the-musthavemenus-tile-to-toast"} className={"ant-btn secondary ant-btn-lg"}>Learn More</a>
  </div>

  return (
  <main className="toast-partner-connect-content">
    <section className="one">
      <div className="content">
        <div className="flex">
          <div className="text">
            <img className="toast-logo" src="https://timber.mhmcdn.com/site/marketing/icons/ToastWordmark.svg" alt="Toast Wordmark"/>
            <img className="mobile-only hero" src="https://timber.mhmcdn.com/site/marketing/homepage/HomeHero.webp" alt="Toast Hero"/>
            <h1>Connect your<br className="desktop-only"/> Menu Data</h1>
            <p>Sync your existing technology with MustHaveMenus to easily create new menus and manage your marketing.</p>
            {buttonSet}
          </div>
          <div className="img desktop-only">
            <img src="https://timber.mhmcdn.com/site/content/tpc/TPCHeroMay24.webp" alt="Toast Hero"/>
          </div>
        </div>
      </div>
    </section>

    <section className="two gray-bg">
      <div className="content">
        <div className="flex">
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/ChooseTemplate.svg" alt="Pick a Template"/>
            <h3>Pick a Template</h3>
            <p>Choose from over 25,000 customizable templates crafted just for restaurants.</p>
          </div>
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Toast.svg" alt="Connect to Toast"/>
            <h3>Connect to Toast</h3>
            <p>An easy, one-time setup makes your Toast data available to drop into any design.</p>
          </div>
          <div className="item">
            <img className="small" src="https://timber.mhmcdn.com/site/marketing/icons/Import.svg" alt="Add Menu Data"/>
            <h3>Add Menu Data</h3>
            <p>Format your design and try new layouts in just a few clicks.</p>
          </div>
          <div className="item">
            <img className="small" src="https://timber.mhmcdn.com/site/marketing/icons/Sync.svg" alt="Sync & Update"/>
            <h3>Sync & Update</h3>
            <p>Always keep your designs up-to-date with your Toast data.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="three">
      <div className="content">
        <div className="flex">
          <div className="text">
            <div className="omm-title">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/OMMWhite.svg" alt="omm" />
              <h2>The One Minute Menu<br/><i>&mdash; with Automatic Updates!</i></h2>
            </div>
            <p>Save time and improve accuracy by using menu items pulled directly from your POS. With auto-update, your downloaded menus and digital boards will always reflect the POS!</p>
            <h2>Simple Menu Management</h2>
            <p>Sync your menus to your Toast data to keep them up-to-date.</p>
            {buttonSet}
          </div>
          <div className="img">
            <video autoPlay loop muted playsInline src="https://timber.mhmcdn.com/site/marketing/homepage/OMMJun24.mp4" />
          </div>
        </div>
      </div>
    </section>

    <section className="four text-center gray-bg">
      <div className="content">
        <h2>We offer Menu Services</h2>
        <div className="flex flex-one">
          <div className="item">
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="Customer Service"/>
            </div>
            <h3>Talk to a live menu expert</h3>
          </div>
          <div className="item">
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/MSRequest.svg" alt="MS Request"/>
            </div>
            <h3>Send us your data</h3>
          </div>
          <div className="item">
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Calendar3-4.svg" alt="Calendar"/>
            </div>
            <h3>Get a menu within 3-4<br/>business days, or less</h3>
          </div>
        </div>
        <div className="flex flex-two">
          <div className="text">
            <h3>Menu updates taking too long?<br/>We'll save you time and money.</h3>
            <p>Use our design and onboarding services for all of your menus — breakfast, lunch, dinner, drinks, catering and more.</p>
            <div className="desktop-only btn">
              <a href={"/feature/menu-services.html"} className={"ant-btn ant-btn-primary ant-btn-lg"}>See Menu Services</a>
            </div>
          </div>
          <div className="img">
            <video muted autoPlay loop playsInline src="https://timber.mhmcdn.com/site/marketing/homepage/HomeMS.mp4"/>
            <div className="mobile-only btn">
              <a href={"/feature/menu-services.html"} className={"ant-btn ant-btn-primary ant-btn-lg"}>See Menu Services</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="five text-center">
      <div className="content">
        <img src="https://timber.mhmcdn.com/site/marketing/icons/Quotes.svg" alt="Quotes"/>
        <div className="best">The Best Menu Maker App</div>
        <div className="sbt">Small business trends<span className="desktop-only"> | </span><br className="mobile-only"/>Jan '22</div>
      </div>
    </section>

    <section className="six gray-bg text-center">
      <div className="content">
        <h2>Create more marketing touchpoints</h2>
        <div className="flex">
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/feature/toast/ToastMarketing1.webp" alt="Traditional Menus"/>
            <h3>Traditional Menus</h3>
          </div>
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/feature/toast/ToastMarketing2.webp" alt="Contactless Menus"/>
            <h3>Contactless Menus</h3>
          </div>
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/feature/toast/ToastMarketing3.webp" alt="Digital Signage"/>
            <h3>Digital Signage</h3>
          </div>
          <div className="item">
            <img src="https://timber.mhmcdn.com/site/feature/toast/ToastMarketing4.webp" alt="QR Codes"/>
            <h3>QR Codes</h3>
          </div>
        </div>
      </div>
    </section>

    <section className="seven text-center">
      <div className="content">
        <div className="testimony-header">
          <div className="quotes"><img src="https://timber.mhmcdn.com/site/marketing/icons/QuotesWhite.svg" alt="Quotes"/></div>
          <h2>What our customers are saying...</h2>
        </div>
        {!mobile &&
        <div className="flex">
          <div className="quote-slide">
            <div className="quote">
              <div className="logo">
                <img src="https://timber.mhmcdn.com/site/feature/toast/ElRanchoLogo.svg" alt="El Rancho Logo"/>
              </div>
              <p>
                "MustHaveMenus + Toast is truly a killer combo. It's efficient, looks fantastic, and really makes our establishment appear first class."
              </p>
            </div>
            <div className="attribution">
              <h3>Glen</h3>
              <p>El Rancho Brewing Company</p>
            </div>
          </div>
          <div className="quote-slide">
            <div className="quote">
              <div className="logo short-logo">
                <img src="https://timber.mhmcdn.com/site/feature/toast/MemoryCharcoalLogo.svg" alt="Memories Charcoal House Logo"/>
              </div>
              <p>"This Toast partnership will save me tons of time. I have used MustHaveMenus for a few years now, and to have this feature is an absolute game changer!"</p>
            </div>
            <div className="attribution">
              <h3>Andrea</h3>
              <p>Memories Charcoal House</p>
            </div>
          </div>
          <div className="quote-slide">
            <div className="quote">
              <div className="logo short-logo">
                <img src="https://timber.mhmcdn.com/site/feature/toast/RawLogo.svg" alt="NW Raw Logo"/>
              </div>
              <p>"The time this integration with Toast will save for customers — it's insane!"</p>
            </div>
            <div className="attribution">
              <h3>Rachel</h3>
              <p>NW RAW</p>
            </div>
          </div>
        </div>}
        {mobile && 
        <Carousel autoplay autoplaySpeed={5000} pauseOnFocus arrows={true} nextArrow={<RightOutlined/>} prevArrow={<LeftOutlined/>} dots={false}>
          <div className="slide-container">
            <div className="quote-slide">
              <div className="quote">
                <div className="logo">
                  <img src="https://timber.mhmcdn.com/site/feature/toast/ElRanchoLogo.svg" alt="El Rancho Logo"/>
                </div>
                <p>
                  "MustHaveMenus + Toast is truly a killer combo. It's efficient, looks fantastic, and really makes our establishment appear first class."
                </p>
              </div>
              <div className="attribution">
                <h3>Glen</h3>
                <p>El Rancho Brewing Company</p>
              </div>
            </div>
          </div>
          <div className="slide-container">
            <div className="quote-slide">
              <div className="quote">
                <div className="logo short-logo">
                  <img src="https://timber.mhmcdn.com/site/feature/toast/MemoryCharcoalLogo.svg" alt="Memories Charcoal House Logo"/>
                </div>
                <p>"This Toast partnership will save me tons of time. I have used MustHaveMenus for a few years now, and to have this feature is an absolute game changer!"</p>
              </div>
              <div className="attribution">
                <h3>Andrea</h3>
                <p>Memories Charcoal House</p>
              </div>
            </div>
          </div>
          <div className="slide-container">
            <div className="quote-slide">
              <div className="quote">
                <div className="logo short-logo">
                  <img src="https://timber.mhmcdn.com/site/feature/toast/RawLogo.svg" alt="NW Raw Logo"/>
                </div>
                <p>"The time this integration with Toast will save for customers — it's insane!"</p>
              </div>
              <div className="attribution">
                <h3>Rachel</h3>
                <p>NW RAW</p>
              </div>
            </div>
          </div>
        </Carousel>}
      </div>
    </section>
  </main>
  )
}